import React from 'react';
import moment from 'moment';

class TournamentWatchDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tournaments: props.tournaments,
            sort: {
                columnName: 'Name',
                order: 'asc'
            }
        }
    }

    getMinsToStartDisplay = (time) => {
        const duration = moment.duration(Math.abs(time))
        let timeString = `${duration.hours()}:${duration.minutes()}`
        if (time < 0) return `-${timeString}`;
        else return timeString;
    }

    componentWillReceiveProps(props) {
        this.setState({ tournaments : props.tournaments })
    }
    
    NoDataMsg = () => (<h3 style={{ textAlign: 'center', color: 'white' }}>No Data Available</h3>);

    TableHeader = () => (
        <div className="table-header">
            <div onClick={_ => this.props.onSort('Name')} id="th-name">Name&nbsp;<i className="fa fa-sort " data-e2e="Name"></i></div>
            <div onClick={_ => this.props.onSort('minsToReg')} >Mins to Reg&nbsp;<i className="fa fa-sort " data-e2e="Mins to Reg"></i></div>
            <div onClick={_ => this.props.onSort('BuyIn')} >Buy In&nbsp;<i className="fa fa-sort " data-e2e="Buy In"></i></div>
            <div onClick={_ => this.props.onSort('minsToStart')} >Mins to Start&nbsp;<i className="fa fa-sort " data-e2e="Mins to Start"></i></div>
            <div onClick={_ => this.props.onSort('PredictedOverlayRegistration')} >Overlay People&nbsp;<i className="fa fa-sort " data-e2e="OverLay People" ></i></div>
            <div onClick={_ => this.props.onSort('PredictedOverlay')} >Predicted Overlay&nbsp;<i className="fa fa-sort " data-e2e="Predicted Overlay"></i></div>
            <div onClick={_ => this.props.onSort('PrizePool')} >Prize Pool&nbsp;<i className="fa fa-sort " data-e2e="Prize Pool"></i></div>
            <div onClick={_ => this.props.onSort('RegPlayersCount')} >Reg Players Count&nbsp;<i className="fa fa-sort " data-e2e="Reg Player Count"></i></div>
            <div></div>
        </div>
    )

    TdCell = (props = {id : '', text : '', title : ''}) => (
        <div id={props.id}>
            <span className="tr-title">
                <strong>
                    {props.title} :
                </strong>
            </span>
            {props.text}
        </div>
    )
    
    render() {
        const { tournaments } = this.state;
        return (
            <div data-e2e='tournmentWatchData'>
                {tournaments.length == 0 ?
                    <this.NoDataMsg />
                    : <div className="table-main">
                        <this.TableHeader />
                        <div className='table-body' data-e2e="tournmentWatchTable">
                            {tournaments.map((tournament, key) => {
                                return (
                                    <div style={{ backgroundColor: tournament.flag.color }} className="table-row">
                                        <this.TdCell id='td-name' text={tournament.Name} title={'Name'} />
                                        <this.TdCell text={this.getMinsToStartDisplay(tournament.minsToReg)} title={'Mins to Reg'} />
                                        <this.TdCell text={tournament.BuyIn.toFixed(2)} title={'Buy In'} />
                                        <this.TdCell text={this.getMinsToStartDisplay(tournament.minsToStart)} title={'Mins to Start'} />
                                        <this.TdCell text={tournament.PredictedOverlayRegistration} title={'Overlay People'} />
                                        <this.TdCell text={tournament.PredictedOverlay.toFixed(2)} title={'Predicted Overlay'} />
                                        <this.TdCell text={tournament.PrizePool.toFixed(2)} title={'Prize Pool'} />
                                        <div>
                                            <span className="tr-title">
                                                <strong>
                                                    Reg Players Count :
                                                </strong>
                                            </span>
                                            <button
                                                type="button"
                                                onClick={() => this.props.openEditReg(tournament)}
                                                className="btn"
                                                style={{
                                                    background: "rgba(24, 24, 25, 0.2)",
                                                    margin: '0% 2%',
                                                    width: "60%"
                                                }}
                                                data-e2e="regPlayerCount"
                                            >
                                               {tournament.RegPlayersCount}
                                            </button>
                                        </div>
                                        <div>
                                            <span className="tr-title">
                                                &nbsp;
                                            </span>
                                            <button
                                                type="button"
                                                onClick={() => this.props.onView(tournament.tournamentId)}
                                                className="btn"
                                                style={{
                                                    background: "#1F1F23",
                                                    margin: '0% 2%',
                                                    color : 'white',
                                                    width: "75%"
                                                }}
                                                data-e2e="viewDetailsButton"
                                            >
                                                View
                                            </button>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default TournamentWatchDisplay;


/** WEBPACK FOOTER **
 ** ./src/components/TournamentWatch/TournamentWatchDisplay.js
 **/